export default "__VITE_ASSET__e78fYXcm__"